// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function debounce(func: (...args: any[]) => void, waitMs: number) {
  let timeout: number | undefined;
  return (...args: unknown[]) => {
    clearTimeout(timeout);
    timeout = window.setTimeout(() => {
      timeout = undefined;
      func(...args);
    }, waitMs);
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function throttle(func: (...args: any[]) => void, timeFrameMs: number) {
  let lastTime = 0;
  return (...args: unknown[]) => {
    const now = new Date().getTime();
    if (now - lastTime >= timeFrameMs) {
      func(...args);
      lastTime = now;
    }
  };
}

export function arraysEqual<T>(array1: T[], array2: T[]): boolean {
  if (array1.length !== array2.length) {
    return false;
  }

  for (let i = 0; i < array1.length; i++) {
    if (array1[i] !== array2[i]) {
      return false;
    }
  }

  return true;
}
